(() => {
  function activateTab(section, tabId) {
    section.querySelectorAll('[data-product-detail-tabs-tab]').forEach((tab) => {
      const isActive = tab.dataset.productDetailTabsTab === tabId;
      tab.setAttribute('aria-selected', String(isActive));

      if (isActive) {
        tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    });

    section.querySelectorAll('[data-product-detail-tabs-panel]').forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.productDetailTabsPanel === tabId);
    });
  }

  function initTabs(section) {
    section.querySelectorAll('[data-product-detail-tabs-tab]').forEach((tab) => {
      if (tab.dataset.bound === 'true') {
        return;
      }

      tab.dataset.bound = 'true';
      tab.addEventListener('click', () => activateTab(section, tab.dataset.productDetailTabsTab));
    });
  }

  function initFaq(section) {
    section.querySelectorAll('.product-detail-tabs__faq-grid').forEach((grid) => {
      if (grid.dataset.bound === 'true') {
        return;
      }

      grid.dataset.bound = 'true';
      grid.addEventListener('toggle', (event) => {
        const item = event.target;

        if (!item.matches('.product-detail-tabs__faq-item[open]')) {
          return;
        }

        grid.querySelectorAll('.product-detail-tabs__faq-item[open]').forEach((openItem) => {
          if (openItem !== item) {
            openItem.removeAttribute('open');
          }
        });
      }, true);
    });
  }

  function initSection(section) {
    initTabs(section);
    initFaq(section);
  }

  document.querySelectorAll('[data-product-detail-tabs]').forEach(initSection);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-product-detail-tabs]').forEach(initSection);
  });
})();
